import Swiper from 'swiper';
import { Autoplay, EffectCreative } from 'swiper/modules';
import { swiperObserver } from '../utils/swiper.utils.js';

let countSwiperWr = document.querySelectorAll('.count-swiper-wr');
countSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, EffectCreative],
      slidesPerView: 1,
      speed: 800,
      threshold: 10,
      loop: slidesCount > 1,
      allowTouchMove: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      effect: "creative",
      creativeEffect: {
        limitProgress: 1,
        prev: {
          translate: [0, 0, -300],
          rotate: [180, 0, 0],
        },
        next: {
          translate: [0, 0, -300],
          rotate: [-180, 0, 0],
        },
      }
    });
    swiperObserver(swiper);
  }
});
